import { COLIS_COLLECTION, ENTERPRISES_COLLECTION, HYSTORY_COLLECTION } from "../constants/collections";
import { ENTERPRISE_DOC_ID } from "../constants/configs";

const { query, getDoc, doc, collection, getDocs, orderBy, where, limit } = require('firebase/firestore');
const { db } = require('../firebase');

export const getColisInfo = async (colisId) => {
  const ref = query(doc(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, COLIS_COLLECTION, colisId));
  const querySnapshot = await getDoc(ref);

  return querySnapshot.data();
};

export const getColisInfoByCode = async (code) => {
  const ref = query(collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, COLIS_COLLECTION), where('code', '==', code.toUpperCase()), limit(1));
  const querySnapshot = await getDocs(ref);
  const colis = querySnapshot.docs.map((doc) => doc.data());
  const colisInfo = colis[0];
  return colisInfo;
};

export const getAllHistory = async (colisId) => {
    const ref = query(
    collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, COLIS_COLLECTION, colisId, HYSTORY_COLLECTION),
    orderBy('createdAt', 'desc')
  );
  const querySnapshot = await getDocs(ref);

  console.log(querySnapshot.docs.map((value) => value.data()))

  return querySnapshot.docs.map((value) => value.data());

};

